import { render } from "./huodong.vue?vue&type=template&id=bb346562&scoped=true"
import script from "./huodong.vue?vue&type=script&lang=js"
export * from "./huodong.vue?vue&type=script&lang=js"

import "./huodong.vue?vue&type=style&index=0&id=bb346562&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb346562"]])

export default __exports__